/**
 * @flow
 * @relayHash 9359e1b8c89a008e24c14385d953b442
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type DictionaryItem_item$ref = any;
export type FILE_TYPE_GROUP = "DEAL" | "ORGANISATION" | "%future added value";
export type FILE_TYPE_TYPE = "BO_SUBMITTED" | "BUILDING_PLAN" | "COMMERCIAL_REGISTER" | "DOCUMENT" | "GENERAL_NDA" | "LFAIE" | "NBO_SUBMITTED" | "NDA" | "PHOTO" | "POA" | "POWER_OF_ATTORNY" | "RENTAL_STATUS" | "SALES_MEMO" | "SELLING_ACT" | "SIGNED_NDA" | "TEASER" | "TOMBSTONE" | "%future added value";
export type CreateFileTypeInput = {|
  labelEn: string,
  labelFr?: ?string,
  labelDe?: ?string,
  group: FILE_TYPE_GROUP,
  type?: ?FILE_TYPE_TYPE,
  pipelineStageAccess?: ?FileTypePipelineStageAccessInput,
  adminOnlyAccess?: ?boolean,
  clientMutationId?: ?string,
|};
export type FileTypePipelineStageAccessInput = {|
  SELECTED_NOTIFIED: boolean,
  INTERESTED: boolean,
  NDA_SIGNED: boolean,
  NBO_SUBMITTED: boolean,
  VISIT: boolean,
  DUE_DILIGENCE: boolean,
  BO_SUBMITTED: boolean,
  CLOSING: boolean,
|};
export type fileTypesCreateFileTypeMutationVariables = {|
  input: CreateFileTypeInput
|};
export type fileTypesCreateFileTypeMutationResponse = {|
  +createFileType: ?{|
    +node: ?{|
      +$fragmentRefs: DictionaryItem_item$ref
    |}
  |}
|};
export type fileTypesCreateFileTypeMutation = {|
  variables: fileTypesCreateFileTypeMutationVariables,
  response: fileTypesCreateFileTypeMutationResponse,
|};
*/


/*
mutation fileTypesCreateFileTypeMutation(
  $input: CreateFileTypeInput!
) {
  createFileType(input: $input) {
    node {
      ...DictionaryItem_item
      id
    }
  }
}

fragment DictionaryItem_item on Dictionary {
  __typename
  id
  label
  position
  labelEn: label(lang: "en")
  labelFr: label(lang: "fr")
  labelDe: label(lang: "de")
  ... on PipelineStage {
    group
  }
  ... on DealStatus {
    group
  }
  ... on FileType {
    group
    type
    adminOnlyAccess
    pipelineStageAccess {
      SELECTED_NOTIFIED
      INTERESTED
      NDA_SIGNED
      NBO_SUBMITTED
      VISIT
      DUE_DILIGENCE
      BO_SUBMITTED
      CLOSING
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateFileTypeInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "fileTypesCreateFileTypeMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createFileType",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateFileTypePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "FileType",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "DictionaryItem_item",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "fileTypesCreateFileTypeMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createFileType",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateFileTypePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "FileType",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "__typename",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "label",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "position",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": "labelEn",
                "name": "label",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "lang",
                    "value": "en"
                  }
                ],
                "storageKey": "label(lang:\"en\")"
              },
              {
                "kind": "ScalarField",
                "alias": "labelFr",
                "name": "label",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "lang",
                    "value": "fr"
                  }
                ],
                "storageKey": "label(lang:\"fr\")"
              },
              {
                "kind": "ScalarField",
                "alias": "labelDe",
                "name": "label",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "lang",
                    "value": "de"
                  }
                ],
                "storageKey": "label(lang:\"de\")"
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "group",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "type",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "adminOnlyAccess",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pipelineStageAccess",
                "storageKey": null,
                "args": null,
                "concreteType": "FileTypePipelineStageAccess",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "SELECTED_NOTIFIED",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "INTERESTED",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "NDA_SIGNED",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "NBO_SUBMITTED",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "VISIT",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "DUE_DILIGENCE",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "BO_SUBMITTED",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "CLOSING",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "fileTypesCreateFileTypeMutation",
    "id": null,
    "text": "mutation fileTypesCreateFileTypeMutation(\n  $input: CreateFileTypeInput!\n) {\n  createFileType(input: $input) {\n    node {\n      ...DictionaryItem_item\n      id\n    }\n  }\n}\n\nfragment DictionaryItem_item on Dictionary {\n  __typename\n  id\n  label\n  position\n  labelEn: label(lang: \"en\")\n  labelFr: label(lang: \"fr\")\n  labelDe: label(lang: \"de\")\n  ... on PipelineStage {\n    group\n  }\n  ... on DealStatus {\n    group\n  }\n  ... on FileType {\n    group\n    type\n    adminOnlyAccess\n    pipelineStageAccess {\n      SELECTED_NOTIFIED\n      INTERESTED\n      NDA_SIGNED\n      NBO_SUBMITTED\n      VISIT\n      DUE_DILIGENCE\n      BO_SUBMITTED\n      CLOSING\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '30005e9b00747b4ba1d68c5d3a19917f';
module.exports = node;
